import React, {Fragment} from 'react';

const NotFoundScreen = () => {
    return (
        <Fragment>
            404 Page not found.
        </Fragment>
    );
};

export default NotFoundScreen;
